module.exports = __webpack_public_path__ + "img/pr-45.08c5ef35.png";